/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QRCodeCornerDotType,
    QRCodeCornerDotTypeFromJSON,
    QRCodeCornerDotTypeFromJSONTyped,
    QRCodeCornerDotTypeToJSON,
} from './QRCodeCornerDotType';
import {
    QRCodeCornerSquareType,
    QRCodeCornerSquareTypeFromJSON,
    QRCodeCornerSquareTypeFromJSONTyped,
    QRCodeCornerSquareTypeToJSON,
} from './QRCodeCornerSquareType';
import {
    QRCodeDotType,
    QRCodeDotTypeFromJSON,
    QRCodeDotTypeFromJSONTyped,
    QRCodeDotTypeToJSON,
} from './QRCodeDotType';
import {
    QRCodeDrawType,
    QRCodeDrawTypeFromJSON,
    QRCodeDrawTypeFromJSONTyped,
    QRCodeDrawTypeToJSON,
} from './QRCodeDrawType';
import {
    QRCodeShapeType,
    QRCodeShapeTypeFromJSON,
    QRCodeShapeTypeFromJSONTyped,
    QRCodeShapeTypeToJSON,
} from './QRCodeShapeType';

/**
 * 
 * @export
 * @interface QRCodeSettings
 */
export interface QRCodeSettings {
    /**
     * 
     * @type {QRCodeDrawType}
     * @memberof QRCodeSettings
     */
    type: QRCodeDrawType;
    /**
     * 
     * @type {QRCodeShapeType}
     * @memberof QRCodeSettings
     */
    shape?: QRCodeShapeType;
    /**
     * 
     * @type {number}
     * @memberof QRCodeSettings
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof QRCodeSettings
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof QRCodeSettings
     */
    margin?: number;
    /**
     * 
     * @type {string}
     * @memberof QRCodeSettings
     */
    image?: string;
    /**
     * 
     * @type {QRCodeDotType}
     * @memberof QRCodeSettings
     */
    dot_pattern_type?: QRCodeDotType;
    /**
     * 
     * @type {string}
     * @memberof QRCodeSettings
     */
    dot_pattern_color?: string;
    /**
     * 
     * @type {QRCodeCornerSquareType}
     * @memberof QRCodeSettings
     */
    corner_square_type?: QRCodeCornerSquareType;
    /**
     * 
     * @type {string}
     * @memberof QRCodeSettings
     */
    corner_square_color?: string;
    /**
     * 
     * @type {QRCodeCornerDotType}
     * @memberof QRCodeSettings
     */
    corner_dot_type?: QRCodeCornerDotType;
    /**
     * 
     * @type {string}
     * @memberof QRCodeSettings
     */
    corner_dot_color?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeSettings
     */
    background_color?: string;
}

export function QRCodeSettingsFromJSON(json: any): QRCodeSettings {
    return QRCodeSettingsFromJSONTyped(json, false);
}

export function QRCodeSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): QRCodeSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': QRCodeDrawTypeFromJSON(json['type']),
        'shape': !exists(json, 'shape') ? undefined : QRCodeShapeTypeFromJSON(json['shape']),
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'margin': !exists(json, 'margin') ? undefined : json['margin'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'dot_pattern_type': !exists(json, 'dot_pattern_type') ? undefined : QRCodeDotTypeFromJSON(json['dot_pattern_type']),
        'dot_pattern_color': !exists(json, 'dot_pattern_color') ? undefined : json['dot_pattern_color'],
        'corner_square_type': !exists(json, 'corner_square_type') ? undefined : QRCodeCornerSquareTypeFromJSON(json['corner_square_type']),
        'corner_square_color': !exists(json, 'corner_square_color') ? undefined : json['corner_square_color'],
        'corner_dot_type': !exists(json, 'corner_dot_type') ? undefined : QRCodeCornerDotTypeFromJSON(json['corner_dot_type']),
        'corner_dot_color': !exists(json, 'corner_dot_color') ? undefined : json['corner_dot_color'],
        'background_color': !exists(json, 'background_color') ? undefined : json['background_color'],
    };
}

export function QRCodeSettingsToJSON(value?: QRCodeSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': QRCodeDrawTypeToJSON(value.type),
        'shape': QRCodeShapeTypeToJSON(value.shape),
        'width': value.width,
        'height': value.height,
        'margin': value.margin,
        'image': value.image,
        'dot_pattern_type': QRCodeDotTypeToJSON(value.dot_pattern_type),
        'dot_pattern_color': value.dot_pattern_color,
        'corner_square_type': QRCodeCornerSquareTypeToJSON(value.corner_square_type),
        'corner_square_color': value.corner_square_color,
        'corner_dot_type': QRCodeCornerDotTypeToJSON(value.corner_dot_type),
        'corner_dot_color': value.corner_dot_color,
        'background_color': value.background_color,
    };
}

